"use client"

import { MapPinPen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinPenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinPenIcon = component(Icon)({ as: MapPinPen })
